export default "__VITE_ASSET__BiJUnYA1__"